var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    { attrs: { height: "500", viewBox: "0 0 1384 1000" } },
    [
      _c(
        "underwater",
        { attrs: { "show-viewbox": true, overflow: "hidden" } },
        [
          _c(
            "g",
            [
              _c("keyframe-repeat", {
                attrs: { repeat: 250, keyframe: _vm.keyframe },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(delay) {
                      return [
                        _c("octopus", {
                          attrs: { color: "blue", y: -300, x: delay.keyframe }
                        })
                      ]
                    }
                  }
                ])
              }),
              _c("keyframe-repeat", {
                attrs: { repeat: 500, keyframe: _vm.keyframe },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(delay) {
                      return [
                        _c("octopus", {
                          attrs: { color: "blue", y: -50, x: delay.keyframe }
                        })
                      ]
                    }
                  }
                ])
              }),
              _c("keyframe-repeat", {
                attrs: { repeat: 1000, keyframe: _vm.keyframe },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(delay) {
                      return [
                        _c("octopus", {
                          attrs: { color: "blue", y: 200, x: delay.keyframe }
                        })
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }